import alertService from "./alert.service";
import http from './http.service';

class VendedorService {

    vendedores: any = {};
    provincias: any[] = []
    contactos: any = {};

    constructor() {


    }

    getProvincias = (onSuccess: any) => {
        if (this.provincias.length > 0) {
            onSuccess(this.provincias);
        } else {
            http.get("public/vendedor/provincias")
                .then((data: any) => {
                    this.provincias = data.provincias;
                    onSuccess(this.provincias);
                })
                .catch((error: any) => {
                    console.error("Error getting provincias", error)
                })
        }
    }

    /**
     * Los WhatsApp adicionales del vendedor. Se piden recien cuando se abre el modal de
     * consulta (no vienen con el producto) y se cachean por vendedor, porque en un listado
     * el mismo vendedor aparece muchas veces.
     *
     * Si falla no se alerta: el modal igual sirve con el numero principal, y romperle una
     * consulta al comprador por esto seria peor que mostrar una opcion menos.
     */
    traerContactos = (vendedorId: number, onSuccess: any) => {
        if (!vendedorId) {
            onSuccess([]);
            return;
        }

        if (!!this.contactos[vendedorId]) {
            onSuccess(this.contactos[vendedorId]);
        } else {
            http.post("public/vendedor/contactos", {id: vendedorId})
                .then((data: any) => {
                    this.contactos[vendedorId] = data.contactos ?? [];
                    onSuccess(this.contactos[vendedorId]);
                })
                .catch((error: any) => {
                    console.error("Error getting contactos del vendedor", error);
                    onSuccess([]);
                })
        }
    }

    /**
     * Deja en cache los contactos de varios vendedores con una sola request. El listado la
     * llama al traer una pagina de resultados, asi cuando el comprador toca "Consulta" ya
     * se sabe si hay que abrir el modal o ir derecho a WhatsApp.
     *
     * Un vendedor sin contactos queda cacheado como [] igual: eso es justamente lo que
     * habilita el link directo, y evita volver a preguntar por el.
     */
    precargarContactos = (vendedorIds: number[], onDone?: any) => {
        const pendientes = (vendedorIds ?? [])
            .filter((id: number) => !!id && this.contactos[id] === undefined)
            .filter((id: number, i: number, arr: number[]) => arr.indexOf(id) === i);

        if (pendientes.length === 0) {
            if (onDone) onDone();
            return;
        }

        http.post("public/vendedor/contactos-varios", pendientes)
            .then((data: any) => {
                const porVendedor = data.contactosPorVendedor ?? {};

                pendientes.forEach((id: number) => {
                    this.contactos[id] = porVendedor[id] ?? [];
                });

                if (onDone) onDone();
            })
            .catch((error: any) => {
                console.error("Error precargando contactos de vendedores", error);
                if (onDone) onDone();
            })
    }

    /**
     * Lo que hay en cache para ese vendedor: [] si no tiene contactos, undefined si todavia
     * no se pregunto. Quien lo llama tiene que distinguir los dos casos.
     */
    contactosEnCache = (vendedorId: number) => {
        return this.contactos[vendedorId];
    }

    /** El vendedor edito sus contactos: el cache viejo ya no sirve. */
    limpiarCacheContactos = (vendedorId: number) => {
        delete this.contactos[vendedorId];
    }

    /**
     * La tienda publica de un vendedor.
     *
     * <p>`onSuccess(undefined)` cuando la tienda no existe —suspendida, dada de baja, o un id que
     * nunca fue de un vendedor—: el backend responde sin la clave `vendedor` y la pantalla tiene
     * que poder distinguir eso de "todavia esta cargando". Con `{}` no podia, y por eso el cartel
     * de "vendedor no encontrado" no aparecia nunca.
     *
     * <p>El contador de publicaciones viaja aparte del vendedor y se pega al objeto: es un dato de
     * la tienda, no del usuario, y asi la cabecera no tiene que esperar al listado para mostrarlo.
     */
    traerDataVendedor = (vendedorId: number, onSuccess: any) => {
        if (!!this.vendedores[vendedorId]) {
            onSuccess(this.vendedores[vendedorId]);
        } else {
            http.post("public/vendedor/buscarPorId", {id: vendedorId})
                .then((data: any) => {
                    if (!data?.vendedor) {
                        onSuccess(undefined);
                        return;
                    }

                    this.vendedores[vendedorId] = {
                        ...data.vendedor,
                        publicaciones: data.publicaciones ?? 0,
                    };

                    onSuccess(this.vendedores[vendedorId]);
                })
                .catch((error: any) => {
                    alertService.error(error);
                    onSuccess(undefined);
                })
        }


    }

    /**
     * URL canonica de la tienda: `/tienda/1-desarmadero-san-martin`.
     *
     * <p>Mismo formato que `crearUrlProducto` y misma regla: el id adelante es lo unico que se
     * lee, el texto es para la persona y para Google. Asi el vendedor puede cambiarse el nombre
     * sin romper los links que ya circulan.
     */
    crearUrlTienda = (vendedor: any) => {
        if (!vendedor?.id) return '/';

        const nombre = `${vendedor.firstName ?? ''} ${vendedor.lastName ?? ''}`.trim()
            || String(vendedor.username ?? '').split('@')[0];

        const slug = String(nombre)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-+|-+$)/g, '')
            .slice(0, 120);

        return slug ? `/tienda/${vendedor.id}-${slug}` : `/tienda/${vendedor.id}`;
    }

    /**
     * URL del catalogo de la tienda: `/tienda/1-desarmadero-san-martin/catalogo`.
     *
     * <p>Cuelga de la misma URL que la portada en vez de ser `/busqueda?vendedor=1` justamente
     * para que el vendedor la pueda pegar en sus redes: lleva su nombre, se entiende de que es
     * sin abrirla, y no expone un id suelto como si fuera un parametro interno.
     */
    crearUrlCatalogo = (vendedor: any) => {
        const tienda = this.crearUrlTienda(vendedor);

        return tienda === '/' ? '/busqueda' : `${tienda}/catalogo`;
    }

    /** Id de la tienda a partir del slug (`1-desarmadero-...` -> 1). */
    idDesdeSlug = (slug: string) => {
        const match = /^(\d+)/.exec(slug || '');
        return match ? match[1] : undefined;
    }

}


const vendedorService = new VendedorService();

export default vendedorService;